import { gql } from '@apollo/client'

const VERIFY_MFA_SMS_CODE = gql`
  mutation verifyMfaSmsCode($mfaSmsCode: String!) {
    verifyMfaSmsCode(mfaSmsCode: $mfaSmsCode) {
      mfaToken
    }
  }
`

export default VERIFY_MFA_SMS_CODE
